<template>
    <BookingFormLayout
        v-bind="
            bookingFormSharedData
                .setContainerClasses('max-w-4xl')
                .getBookingFormLayoutProps()
        "
    >
        <template #content>
            <div class="space-y-4">
                <div>
                    <ElementWithIdOnMobile :id="SERVICES_SECTION_ID" />
                    <BookingFormTitle class="text-center">
                        {{
                            localizer.translate(
                                TextTokenEnum.BookingForm_SelectAService,
                            )
                        }}
                    </BookingFormTitle>
                </div>

                <div class="space-y-4">
                    <ServiceCard
                        v-for="service in localServices"
                        :key="service.id.value"
                        :service="service"
                        :companySlug="localCompany.slug"
                        :localizer="localizer"
                    />
                </div>
            </div>
        </template>
    </BookingFormLayout>
</template>

<script setup lang="ts">
    import { onMounted, ref } from 'vue'
    import BookingFormLayout from '@/Shared/Layout/BookingForm/BookingFormLayout.vue'
    import ServiceCard from '@/BookingForm/BookingForm/Component/ServiceCard.vue'
    import BookingFormSharedData from '@/Shared/Entity/BookingFormSharedData'
    import useMetaAttribute from '@/Shared/Hook/useMetaAttribute'
    import BookingFormTitle from '@/Shared/Component/BookingFormTitle.vue'
    import usePageScroll from '@/Shared/Hook/usePageScroll'
    import ElementWithIdOnMobile from '@/BookingForm/BookingForm/Component/ElementWithIdOnMobile.vue'
    import LocalizerService from '@/Shared/Service/Localization/LocalizerService'
    import { TextTokenEnum } from '@/Shared/AutoGenerated/LocalizationEnum'
    import Service from '@/App/Service/Entity/Service'
    import Company from '@/App/Company/Entity/Company'

    interface ShowBookingFormServiceStepProps {
        bookingFormSharedDataData: any
        servicesData: any
        companyData: any
    }

    const props = defineProps<ShowBookingFormServiceStepProps>()
    const bookingFormSharedData = BookingFormSharedData.hydrate(
        props.bookingFormSharedDataData,
    )
    const localServices = ref(Service.hydrateMultiple(props.servicesData))
    const localCompany = ref(Company.hydrateSingle(props.companyData))
    const localizer = LocalizerService.make(bookingFormSharedData.currentLocale)

    // -------------------------
    // Lifecycle hooks
    // -------------------------

    onMounted(() => {
        scrollToServicesSection()
    })

    // -------------------------
    // Scroll to services sectio on mobile
    // -------------------------

    const SERVICES_SECTION_ID = 'SERVICES_SECTION_ID'

    const scrollToServicesSection = (): void => {
        usePageScroll().scrollToElement(SERVICES_SECTION_ID)
    }
</script>
